import { Payment, Transaction } from '@models';

export interface PaymentState {
  payments: Payment[];
  payment: Payment | null;
  transaction: Transaction | null;
  fetchedAt: Date | null;
}

export const initialPaymentState: PaymentState = {
  payments: [],
  payment: null,
  transaction: null,
  fetchedAt: null,
};
